import {
  handleGetRequest,
  handlePutRequest,
} from "./http.service";

export interface LabTestOrderUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface LabTestOrderLab {
  _id: string;
  name: string;
  email: string;
  officeAddress: string;
}

export interface LabTestOrderService {
  _id: string;
  description: string;
  amount: number;
}

export interface LabTestOrder {
  _id: string;
  orderRef: string;
  appointmentDate: string;
  status: string;
  paymentStatus: string;
  user: LabTestOrderUser;
  lab: LabTestOrderLab;
  labService: LabTestOrderService;
  createdAt: string;
  updatedAt: string;
}

export interface LabTestOrdersResponse {
  page: number;
  limit: number;
  total: number;
  data: LabTestOrder[];
}

export const getAllLabTestOrders = async (params?: {
  page?: number;
  limit?: number;
  status?: string;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.status) qs.set("status", params.status);
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<LabTestOrdersResponse>(`/lab-test${query}`);
};

export const updateLabTestOrderStatus = async (
  id: string,
  status: string
) =>
  handlePutRequest<{ status: string }, LabTestOrder>(
    `/lab-test/${id}`,
    { status }
  );
